import { useQuery } from '@tanstack/react-query';
import { companyApi } from '@/api/company.api';

export const companyKeys = {
  all: () => ['companies'] as const,
  list: () => [...companyKeys.all(), 'list'] as const,
  // Keep a detail key shape for backwards compat with setQueryData calls
  detail: () => [...companyKeys.all(), 'detail'] as const,
};

/** Returns all companies for the current user (real + demo). */
export const useGetCompanies = () =>
  useQuery({
    queryKey: companyKeys.list(),
    queryFn: companyApi.list,
  });

/** Returns the user's real (non-demo) company, or null if not created yet. */
export const useGetCompany = () => {
  const query = useGetCompanies();
  return {
    ...query,
    data: query.data?.find((c) => !c.isDemo) ?? null,
  };
};

/** Returns the pre-populated demo company. */
export const useGetDemoCompany = () => {
  const query = useGetCompanies();
  return {
    ...query,
    data: query.data?.find((c) => c.isDemo) ?? null,
  };
};
